import { render, staticRenderFns } from "./beneficiary-basic-2.vue?vue&type=template&id=738e09bd&"
import script from "./beneficiary-basic-2.vue?vue&type=script&lang=js&"
export * from "./beneficiary-basic-2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports